"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDTO = void 0;
class CustomerDTO {
    constructor(partial) {
        Object.assign(this, partial);
    }
}
exports.CustomerDTO = CustomerDTO;
//# sourceMappingURL=customer-dto.js.map